import {LIMIT_PAGE_DEFAULT} from "@/shared/constant";
import {CommonStatus} from "@/enums/status";

export class ProvinceParams {
    page = 1;
    limit = LIMIT_PAGE_DEFAULT;
    search = undefined;
    status = CommonStatus.Active;
    countryId = undefined;
}
